import { render, staticRenderFns } from "./Mp4.vue?vue&type=template&id=44884c97"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44884c97')) {
      api.createRecord('44884c97', component.options)
    } else {
      api.reload('44884c97', component.options)
    }
    module.hot.accept("./Mp4.vue?vue&type=template&id=44884c97", function () {
      api.rerender('44884c97', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/fileExtensions/Mp4.vue"
export default component.exports